import { FormLabelProps } from "@chakra-ui/react";

export const boxLabelStyles: FormLabelProps = {
  border: "1px solid black",
  padding: "4",
  margin: 0,
  borderRadius: 0,
  borderLeft: 0,
  borderTop: 0,
};
